import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import JobMessages from './../../../JobMessages/Index'
import RefundReport from './components/RefundReport/Index'
import FeedbackReport from './components/FeedbackReport/Index'

export default {
    name: 'EventDetails',
    computed,
    data,
    methods,
    mounted,
    components: {
      RefundReport,
      JobMessages,
      FeedbackReport
    }
}
